import { useState, useEffect, useRef, useCallback } from 'react'
import { getRecordById } from '@/services/history'
import { RecordFens, Move } from '@/services/types/history'
import SJSlider from '@/components/SJSlider'
import SJButton from '@/components/SJButton'
import ChessBoard from './components/ChessBoard'
import ChessProfile from './components/Profile'
import { useSearchParams } from 'react-router-dom'
import './index.less'
import { Toast } from 'antd-mobile'
import { Player } from '@/services/types/player'
import { getPlayerById } from '@/services/player'

let initFen = ''
// let role = 'Black'
const vwidth = document.body.clientWidth

const ChessHistory = () => {
  document.title = '复盘'
  const [searchParams] = useSearchParams()
  const sessionId = searchParams.get('sessionId')
  const playerId = searchParams.get('playerId')
  const [moves, setMoves] = useState<Move[]>([])
  // rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR
  const [fen, setFen] = useState('')
  const [step, setStep] = useState(0)

  const [player, setPlayer] = useState<Player>()

  const handleGetPlayer = useCallback(async () => {
    if (!playerId) {
      Toast.show('没有棋手id')
      return
    }
    const res = (await getPlayerById(playerId)) as unknown as Player
    setPlayer(res)
  }, [playerId])

  const fetchData = useCallback(async () => {
    if (!sessionId) return
    try {
      const result = (await getRecordById(sessionId)) as unknown as RecordFens
      // const result: RecordFens = {
      //   // session_id: '801c0fb0-2fd4-4744-89b1-db3202f9c5b2',
      //   // user_id: 'p_1519882103775354880',
      //   user_role: 'RED',
      //   // duid: 'SC211WCHFC22C00024',
      //   // status: 'RWIN',
      //   // game_mode: 1,
      //   // total_round: 2,
      //   robot_strength: 1,
      //   start_time: 1652099948,
      //   end_time: 1652099969,
      //   recording: {
      //     fen: 'rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR',
      //     moves: [
      //       { fen: 'rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/4C2C1/9/RNBAKABNR' },
      //       {
      //         fen: 'rnba1abnr/4k4/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/4C2C1/9/RNBAKABNR',
      //         spend_time: 6,
      //         win_percentage: 50,
      //       },
      //       { fen: 'rnba1abnr/4k4/1c5c1/p1p1p1p1p/9/2P6/P3P1P1P/4C2C1/9/RNBAKABNR', spend_time: 6 },
      //       {
      //         fen: 'rnba1ab1r/4k4/1c4nc1/p1p1p1p1p/9/2P6/P3P1P1P/4C2C1/9/RNBAKABNR',
      //         spend_time: 13,
      //         win_percentage: 50,
      //       },
      //       { fen: 'rnba1ab1r/4k4/1c4nc1/p1p1p1p1p/9/2P6/P3P1P1P/R3C2C1/9/1NBAKABNR' },
      //       { fen: 'rn1a1ab1r/4k4/1c2b1nc1/p1p1p1p1p/9/2P6/P3P1P1P/R3C2C1/9/1NBAKABNR' },
      //       { fen: 'rn1a1ab1r/4k4/1c2b1nc1/p1p1C1p1p/9/2P6/P3P1P1P/R6C1/9/1NBAKABNR' },
      //       { fen: 'rn1a1ab1r/4k4/1c2b1n2/p1p1C1p1p/9/2P6/P3P1P1P/R6C1/9/1NBAKABcR' },
      //     ],
      //   },
      // }

      initFen = result.recording.fen
      // if (result.user_role) {
      //   role = result.user_role
      // }
      setMoves([{ fen: initFen, spend_time: 0 }, ...result.recording.moves])
      setFen(initFen)
    } catch (error) {}
  }, [sessionId])

  useEffect(() => {
    handleGetPlayer()
    fetchData()
  }, [handleGetPlayer, fetchData])

  const handlePrev = () => {
    if (step <= 0) {
      Toast.show('已经是第一步了')
      return
    } else {
      setStep(step - 1)
    }
  }
  const handleNext = () => {
    if (step >= moves.length - 1) {
      Toast.show('已经是最后一步了')
      return
    } else {
      setStep(step + 1)
    }
  }
  const onSliderChange = (val: any) => {
    setStep(val)
  }

  // useEffect中不能用debounce, useDebounce, timeout每次都会被清空
  const timeout = useRef<any>()
  useEffect(() => {
    console.log('step', step)
    if (timeout.current) clearTimeout(timeout.current)
    timeout.current = setTimeout(() => {
      moves[step] && setFen(moves[step].fen)
    }, 100)
    return () => {
      if (timeout.current) clearTimeout(timeout.current)
    }
  }, [step, moves])

  return (
    <div className="page chess-history">
      {/* <div className='chess-top'>
        <div className='top-bar'>
          <div className='left'>
            <div className='title'>当前局时</div>
            {data ? (
              <div className='time'>
                {Math.floor((data.end_time - data.start_time) / 60)} : {(data.end_time - data.start_time) % 60}
              </div>
            ) : null}
          </div>
        </div>
      </div> */}
      <ChessProfile type="robot" position="right" />
      <div className="chess-board" style={{ width: vwidth, height: vwidth }}>
        <ChessBoard fen={fen} width={vwidth} type="view"></ChessBoard>
      </div>
      <ChessProfile
        type="human"
        position="left"
        player={{ name: player?.name || '棋手', avatarUrl: player?.avatarUrl || '' }}
      />
      <div className="chess-process">
        <div className="process-text">
          <span className="fs10" style={{ marginRight: '10px' }}>
            当前步数
          </span>
          <span className="fs16">
            {step} / {moves.length - 1}
          </span>
        </div>
        <SJSlider
          value={step}
          min={0}
          max={moves.length - 1}
          onAfterChange={onSliderChange}
        ></SJSlider>
      </div>
      <div className="chess-step">
        <SJButton onClick={handlePrev}>上一步</SJButton>
        <SJButton type="primary" onClick={handleNext}>
          下一步
        </SJButton>
      </div>
    </div>
  )
}

export default ChessHistory
